<footer dir="ltr" [ngClass]="{
  'bg-indigo-700 text-white py-8': business?.template_id === 'home-three',
  'bg-gray-100 text-gray-800 py-8': business?.template_id === 'home-six',
  'bg-pink-200 text-white py-8': business?.template_id === 'home-two',
  'bg-red-400 text-white py-8': business?.template_id === 'home-five',
  'footer': business?.template_id !== 'home-three' && business?.template_id !== 'home-six' && business?.template_id !== 'home-two' && business?.template_id !== 'home-five'
}">
  <div class="w-full">
    <!-- ==== SPECIAL TEMPLATES ==== -->
    <div
      *ngIf="business?.template_id === 'home-three' || business?.template_id === 'home-six' || business?.template_id === 'home-two' || business?.template_id === 'home-five'; else defaultFooter"
      class="container mx-auto">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
        <!-- Copyright – ALWAYS LEFT -->
        <div class="text-left">
          <p class="text-sm" [ngClass]="business?.template_id === 'home-six' ? 'text-gray-800' : 'text-white'">
            © {{ currentYear }} Powered By
            <a href="https://qode.qa/" target="_blank" class="underline hover:text-yellow-400 transition-colors">Qode
              Technologies</a>.
            All rights reserved.
          </p>
        </div>

        <!-- Social Icons – ALWAYS RIGHT -->
        <div class="text-right">
          <div class="flex justify-end space-x-4">
            <a *ngFor="let social of getSocialMediaLinks()" [href]="social.link" target="_blank"
              rel="noopener noreferrer" class="social-icon"
              [ngClass]="business?.template_id === 'home-six' ? 'text-black hover:text-yellow-400' : 'text-white hover:text-yellow-400'"
              [title]="social.platform">
              <i [ngClass]="social.icon" class="text-xl"></i>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- ==== DEFAULT FOOTER ==== -->
    <ng-template #defaultFooter>
      <div class="footer-copyright">
        <div class="container w-full">
          <div class="row">
            <!-- Copyright – ALWAYS LEFT -->
            <div class="col-md-6 col-xs-12 text-left">
              <div class="copy-right">
                © {{ currentYear }} Powered By
                <a href="https://qode.qa/" target="_blank">Qode Technologies</a>.
                All rights reserved
              </div>
            </div>

            <!-- Social Icons – ALWAYS RIGHT -->
            <div class="col-md-6 col-xs-12 text-right">
              <ul class="social-media d-flex justify-content-end">
                <li *ngFor="let social of getSocialMediaLinks()">
                  <a [href]="social.link" [ngClass]="social.icon" target="_blank" rel="noopener noreferrer"></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</footer>